import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Fab } from '@material-ui/core'
import WsC from './providers/WsC';

export default class RaspunsDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }

    selectFile = (id) => {

        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()

    }

    uploadPoza = async (id, idRaspuns, bkId) => {


        let ws = new WsC();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        let chPoza = document.getElementById(bkId)
        let icon = document.getElementById('raspuns-icon')

        icon.style.display = 'none'



        reader.onload = async () => {
            let fileContent = reader.result;
            chPoza.style.backgroundImage = ` url(${fileContent})`
            //  console.log(fileContent);
            console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/UpdatePozaRaspuns/?idRaspuns', saveFile, idRaspuns);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {


                this.props.getRaspunsuri()

            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);


        }
    }





    render() {
        return (
            <div>
                <Dialog
                    className="insertDialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                    <Fab onClick={this.props.dialogClose} className="chestionare-anuleaza-button">
                            <i className='material-icons textPrimary iconFontSize'>close</i>
                        </Fab>

                    </DialogActions>
                    <DialogContent
                        style={{
                            backgroundColor: 'white',
                            borderRadius: 20,
                            position: 'relative',
                            width: '95%',
                            margin: 'auto',
                            marginBottom: 30,
                            // padding: 0,
                            height: 'inherit',
                            overflowX: 'hidden',
                            overflowY: 'scroll',
                            padding:'10px 0 10px 0'
                        }}>
                        {this.props.tipRaspuns.includes('img') &&

                            <div>
                                <div
                                    onClick={() => { this.selectFile(`file-poza-raspuns`) }}
                                    //onClick={()=>{this.openPozaRaspuns()}}
                                    className='pm-angajati-picture'
                                    id='raspuns-image-view'
                                    style={{
                                        width: 200,
                                        textAlign:'center',
                                        height: 200,
                                        borderRadius: 5,
                                        backgroundSize: 'contain',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundImage: this.props.raspuns.img_src !== null ? `url('${new WsC().adresaMedia + `/Chestionare/Raspunsuri_img/${this.props.raspuns.img_src}`}')` : ''
                                    }} >
                                    <i
                                        id='raspuns-icon'
                                        style={{
                                            cursor: 'pointer',
                                            fontSize: 191,
                                            display: this.props.raspuns.img_src !== null ? 'none' : 'block'
                                        }}
                                        className='material-icons'>image</i>

                                </div>

                                <input type='file' id={`file-poza-raspuns`}
                                    style={{ display: 'none' }}
                                    accept='image/*'
                                    onChange={() => { this.uploadPoza('file-poza-raspuns', this.props.raspuns.id, 'raspuns-image-view') }}
                                />

                            </div>


                        }

                        {!this.props.tipRaspuns.includes('img') &&

                            <div style={{ textAlign: 'center' }}>

                                <TextField label='Rapsuns'
                                    autoFocus
                                    style={{ width: '90%', margin: 'auto' }}
                                    value={this.props.nume}
                                    onChange={this.props.numeChange}
                                    className='inputFocus' />
                            </div>
                        }

                        <div style={{ textAlign: 'center' }}>
                            <TextField label='Puncte'
                                type='number'
                                style={{ width: '90%', margin: 'auto' }}
                                value={this.props.puncte || ''}
                                onChange={this.props.puncteChange}
                                className='inputFocus' />
                         </div>       

                    </DialogContent>




                        <DialogActions className="chestionare-dialog-bottom-buttons">

                            <Button style={{ width: '90%', marginBottom: 20 }} variant="contained" onClick={this.props.insertUpdate} className='creeaza-button'>
                                <i className='material-icons'>add_circle_outline</i> Salveaza
                                    </Button>





                        </DialogActions>

                </Dialog>
            </div>
        );
    }
}